import React, { useContext } from 'react';
import { ActualIconProps } from 'mobx/commonTypes';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'uiContext';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';

export default function IconSnowLittle({
  style,
  extColor,
  isAutoscallable = true,
  sizeKey = '32x32',
}: ActualIconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.customBackgrounds.contrast;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      width={w}
      height={h}
      viewBox="0 0 32 32"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.4746 10.241C22.4227 10.241 22.3727 10.2489 22.3221 10.2489C21.744 7.81373 19.5633 6 16.9506 6C14.207 6 11.9375 8.00181 11.5061 10.6238C11.1635 10.5271 10.8051 10.4738 10.4309 10.4738C8.53103 10.4738 6.94551 11.8016 6.5391 13.5778C5.05352 14.1591 4 15.602 4 17.2934C4 19.5017 5.78808 21.2898 7.99573 21.2898H22.4746C25.5267 21.2898 28 18.8184 28 15.767C28 12.7157 25.526 10.241 22.4746 10.241Z"
        fill="white"
      />
      <path
        d="M12.7223 25.5099C13.3684 25.3574 13.7686 24.7099 13.6161 24.0638C13.4636 23.4176 12.8161 23.0174 12.17 23.1699C11.5238 23.3224 11.1236 23.9699 11.2761 24.616C11.4287 25.2622 12.0761 25.6624 12.7223 25.5099Z"
        fill="white"
      />
      <path
        d="M19.0098 25.1801C19.4793 24.7107 19.4793 23.9495 19.0098 23.48C18.5404 23.0106 17.7792 23.0106 17.3098 23.48C16.8403 23.9495 16.8403 24.7107 17.3098 25.1801C17.7792 25.6496 18.5404 25.6496 19.0098 25.1801Z"
        fill="white"
      />
    </svg>
  );
}
